import 'regenerator-runtime/runtime';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import i18n from './plugins/vue-i18n';
import acl from './plugins/acl';
import './plugins/axios';
import './plugins/vuelidate';
import './plugins/vuelidate-error-extractor';
import './plugins/socket';
import './plugins/socketChat';
import SvgIcon from '@/components/SvgIcon';
import DefaultLayout from '@/layouts/default';
import EmptyLayout from '@/layouts/empty';
import numberOnly from '@/directives/numberOnly';
import { get } from 'lodash';
// import './registerServiceWorker';
import phoneNumberOnly from './directives/phoneNumberOnly';

Vue.config.productionTip = false;

/**
 * Template Chaining Optional Handle
 */
Vue.prototype.$get = get;

/**
 * Components Auto Register
 */
Vue.component('defaultLayout', DefaultLayout);
Vue.component('emptyLayout', EmptyLayout);
Vue.component('SvgIcon', SvgIcon);
Vue.directive('number', numberOnly);
Vue.directive('phone', phoneNumberOnly);

console.log('runn..');
new Vue({
  i18n,
  router,
  acl,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
